import React, { useEffect } from "react";
import { X } from "lucide-react";
// import "./JobSkillsModal.css";

const modalStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.4)",
    zIndex: 1000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modal: {
    background: "#fff",
    borderRadius: "8px",
    minWidth: "350px",
    maxWidth: "90vw",
    padding: "24px",
    position: "relative",
    boxShadow: "0 2px 16px rgba(0,0,0,0.2)",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "16px",
  },
  title: { fontSize: "1.25rem", fontWeight: 600 },
  closeBtn: {
    background: "none",
    border: "none",
    fontSize: "1.5rem",
    cursor: "pointer",
    lineHeight: 1,
  },
  skillsList: { listStyle: "none", padding: 0, margin: 0 },
  skillItem: { padding: "6px 0", borderBottom: "1px solid #eee" },
};

/**
 * Props:
 * - open: boolean
 * - onClose: () => void
 * - title: string
 * - skills: array (hard: string[] | {name}[], soft: {name, value}[])
 * - variant: "default" | "job-skills"
 * - type: "hard" | "soft"   (only used when variant="job-skills")
 * - onRemoveSkill?: (skill) => void  (optional, only for hard skills)
 */
const ViewMoreModal = ({
  open,
  onClose,
  title = "Skills",
  skills = [],
  variant = "default",
  type = "hard",
  onRemoveSkill,
}) => {
  // ESC to close
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  // Variant using your class-based CSS
  if (variant === "job-skills") {
    return (
      <div className="job-skills-modal-overlay" onClick={onClose}>
        <div
          className="job-skills-modal-content unique-job-skills-modal"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="job-skills-modal-header">
            <h3>{title}</h3>
            <button
              onClick={onClose}
              className="job-skills-modal-close-btn"
              aria-label="Close"
            >
              <X size={20} />
            </button>
          </div>

          <div className="job-skills-modal-grid">
            {type === "soft"
              ? skills.map((skill, idx) => (
                  <div key={idx} className="soft-skill-item-modal">
                    <span className="soft-skill-name">
                      {(skill && skill.name) || ""}
                    </span>
                    {skill?.value !== undefined && (
                      <span className="soft-skill-value">{skill.value}</span>
                    )}
                  </div>
                ))
              : skills.map((skill, idx) => {
                  const label =
                    typeof skill === "string" ? skill : skill?.name || "";
                  return (
                    <div key={idx} className="job-skill-card">
                      <span>{label}</span>
                      {onRemoveSkill && (
                        <button
                          onClick={() => onRemoveSkill(skill)}
                          className="job-skill-remove-btn"
                          aria-label={`Remove ${label}`}
                        >
                          {/* <X size={14} /> */}
                        </button>
                      )}
                    </div>
                  );
                })}
          </div>
        </div>
      </div>
    );
  }

  // Original inline-styled variant
  return (
    <div style={modalStyles.overlay} onClick={onClose}>
      <div style={modalStyles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={modalStyles.header}>
          <span style={modalStyles.title}>{title}</span>
          <button
            style={modalStyles.closeBtn}
            onClick={onClose}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <ul style={modalStyles.skillsList}>
          {skills.map((skill, idx) => (
            <li key={idx} style={modalStyles.skillItem}>
              {typeof skill === "string" ? skill : skill?.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ViewMoreModal;
